import React from 'react'
import DatePicker from './date_picker'
import * as fmt from '../util/fmt_utils'
import { isSafari } from '../util/random_utils'
import { ensureValidEndDate, isEndAtBeforeStartAt, dateWithYear } from  '../common/components/date_input'

class DateInput extends React.Component {
    constructor(props) {
        super(props)
        this.handleInputChange = this.handleInputChange.bind(this)
        this.handleDatePickerChange = this.handleDatePickerChange.bind(this)
        this.handleBlur = this.handleBlur.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
        this.handleEnterDate = this.handleEnterDate.bind(this)

        this.state = { 
            value:'',
            showCalendar: true,
        }
    }

    componentWillMount() {
        const { value } = this.props

        this.setState({value})
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.value !== nextProps.value) {
            this.setState({ value: nextProps.value })
        }

        // if startAt is changed to after endAt value change endAt value
        const { value: endDate, startAt } = nextProps
        if (isEndAtBeforeStartAt(endDate, startAt)) {
            nextProps.onChange(fmt.numDateShort(startAt))
        }
    }

    handleInputChange(e) {
        this.setState({value: e.target.value})
    }

    handleDatePickerChange(timestamp) {
        const dateString = fmt.numDateShort(timestamp)
        const date = this.validateDate(dateString)
        this.props.onChange(date)
    }

    validateDate(date) {
        const { hasDefaultDate, startAt } = this.props
        const sanitizeDate = fmt.numDateShort(date)
        return ensureValidEndDate(sanitizeDate, hasDefaultDate, startAt)
    }

    handleBlur(e) {
        const date = this.validateDate(e.target.value)
        const dateString = fmt.numDateShort(date)
        this.props.onChange(dateString)
        this.setState({showCalendar: true})
    }

    handleFocus() {
        // if mobile, only show date picker if showCalendar = true
        (!this.props.isMobile || this.state.showCalendar) && this.showDatePicker()
    }

    // only for mobile
    handleEnterDate() {
        // don't focus in Safari 
        !isSafari() && this.input.focus()
        this.hideDatePicker()
        this.setState({showCalendar: false})
    }

    handleKeyDown(e) {
        // hide datepicker when tabbing out of field
        if (e.key === "Tab") {
            this.datePicker.hide()
        }
    }

    showDatePicker() {
        this.datePicker.show()
    }
    
    hideDatePicker() {
        this.datePicker.hide()
    }

    render() {
        const { isMobile } = this.props
        return (
            <span>
                <input
                    type="text"
                    readOnly={isMobile ? this.state.showCalendar : false}
                    ref={input => this.input = input}
                    style={this.props.style || {}}
                    className={this.props.className}
                    placeholder={this.props.placeholder || ''}
                    value={this.state.value}
                    onChange={this.handleInputChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    onClick={this.handleFocus}
                    onKeyDown={this.handleKeyDown}
                />
                <DatePicker
                    ref={ref => this.datePicker = ref}
                    selectedDate={dateWithYear(this.state.value)}
                    onChange={this.handleDatePickerChange}
                    className="hidden"
                    calendarClassName={this.props.calendarClassName}
                    isMobile={isMobile}
                    handleEnterDate={this.handleEnterDate}
                />
            </span>
        )
    }
}

export default DateInput



// WEBPACK FOOTER //
// ./src/components/date_input.jsx